/**
 *@author Mathieu Chantot <mathieu.chantot@hes-so.ch>
 * @date 02/24
 */

export default class MapFeatures{
	constructor(map){
		this.map = map;
		this.ID = [];
		this.featureNumber = 0;
	}
	/**
	 * add a feature to the map
	 * @param {number[]} coordinates - coordinates of the feature
	 * @param {string} geometryType - type of the geometry
	 * @param {string} color - color of the feature
	 * @param {string} lineType - type of the line
	 * @returns {void}
	 */
	addFeature(coordinates, geometryType, color, lineType){
		this.ID.push({'sourceID': 'source' + this.featureNumber, 'layerID': 'layer' + this.featureNumber});
		this.map.current.addSource(this.ID[this.featureNumber].sourceID,{
			type: 'geojson',
			data: {
				type: 'Feature',
				geometry: {
					type: "LineString",
					coordinates: coordinates
				}
			}
		});
		this.map.current.addLayer({
			id: this.ID[this.featureNumber].layerID,
			type: "line",
			source: this.ID[this.featureNumber].sourceID,
			paint: {
			'line-color': color,
			'line-width': 2,
			'line-dasharray': lineType === 'dotted' ? [1, 1] : [1]
			}
		});
		this.featureNumber++;
	}

	/**
	 * delete all the features from the map
	 * @returns {void}
	 */                 
	deleteFeatures(){
		for (let i = 0; i < this.featureNumber; i++){
			if(this.map.current.getLayer(this.ID[i].layerID)) {
				this.map.current.removeLayer(this.ID[i].layerID);
			  }
			if(this.map.current.getSource(this.ID[i].sourceID)){
				this.map.current.removeSource(this.ID[i].sourceID);
			}
		}
		this.ID = [];
		this.featureNumber = 0;
	}
 }